export function PhoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.543 2.543a2 2 0 012.909.085l3.268 3.677c.218.245.314.576.26.9A17.975 17.975 0 017.204 21.98a1.085 1.085 0 01-.899-.26l-3.677-3.268a2 2 0 01-.085-2.909l2.595-2.595a2 2 0 012.716-.105l2.28 1.955a12.284 12.284 0 004.664-4.664l-1.955-2.28a2 2 0 01.105-2.716l2.595-2.595zm1.414 1.414l-2.595 2.595 2.369 2.764c.279.326.336.787.144 1.17a14.285 14.285 0 01-6.388 6.389 1.066 1.066 0 01-1.171-.144l-2.764-2.37-2.595 2.596 3.345 2.973A15.975 15.975 0 0019.93 7.302l-2.973-3.345z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
